import { Repayment } from "components/organisms/forms/advance/advanceLabelForm";

export const advanceFormToQuery = (formData: Repayment) => {
  return {
    ...formData,
    repayments: formData.repayments.map((repayment) => ({
      amount: `${repayment.amount} ${"PLN"}`,
      repaymentDate: repayment.repaymentDate,
      repaymentSource: repayment.repaymentSource,
      repaymentDocument: repayment.repaymentDocument,
      isPaidFromNet: repayment.isPaidFromNet,
    })),
  };
};
